module.exports = __webpack_public_path__ + "img/license_screen.edb0ac3b.jpg";